var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewerRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_142)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_26_142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_142",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.504639,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5047 15.15C13.5213 15.15 14.384 14.7957 15.0927 14.087C15.8007 13.379 16.1547 12.5167 16.1547 11.5C16.1547 10.4833 15.8007 9.62067 15.0927 8.912C14.384 8.204 13.5213 7.85 12.5047 7.85C11.488 7.85 10.6257 8.204 9.91765 8.912C9.20898 9.62067 8.85465 10.4833 8.85465 11.5C8.85465 12.5167 9.20898 13.379 9.91765 14.087C10.6257 14.7957 11.488 15.15 12.5047 15.15ZM12.5047 14.2C11.7547 14.2 11.1173 13.9373 10.5927 13.412C10.0673 12.8873 9.80465 12.25 9.80465 11.5C9.80465 10.75 10.0673 10.1123 10.5927 9.587C11.1173 9.06233 11.7547 8.8 12.5047 8.8C13.2547 8.8 13.8923 9.06233 14.4177 9.587C14.9423 10.1123 15.2047 10.75 15.2047 11.5C15.2047 12.25 14.9423 12.8873 14.4177 13.412C13.8923 13.9373 13.2547 14.2 12.5047 14.2ZM12.5047 18C10.338 18 8.36298 17.4127 6.57965 16.238C4.79632 15.0627 3.46298 13.4833 2.57965 11.5C3.46298 9.51667 4.79632 7.93733 6.57965 6.762C8.36298 5.58733 10.338 5 12.5047 5C14.6713 5 16.6463 5.58733 18.4297 6.762C20.213 7.93733 21.5463 9.51667 22.4296 11.5C21.5463 13.4833 20.213 15.0627 18.4297 16.238C16.6463 17.4127 14.6713 18 12.5047 18Z",
    fill: "#B4B4C7"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.504639)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_26_142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.504639)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewerRole);
export default __webpack_public_path__ + "static/media/viewer-role.020760191793886e77aaeb578e03a32c.svg";
export { ForwardRef as ReactComponent };